export const MULTI_TIMELINE_CONFIG = {
	eventsBlockWebTabletHeight: 300,
}